import $ from 'jquery';
import Component from '../models/Component';

export default class LockerImages extends Component {
    constructor(element, context) {
        super(element, context);

        $(document).ready(() => {
            this.$element = $(element);
            this.textSections = this.$element.find('.locker__section');
            this.images = this.$element.find('.locker__image');
            
            // Definiamo la nostra media query per schermi desktop
            this.desktopMediaQuery = window.matchMedia('(min-width: 1024px)');
            
            // Inizializziamo l'observer a null
            this.observer = null; 

            if (!this.textSections.length || !this.images.length) {
                console.warn('LockerImages: Elementi necessari non trovati.');
                return;
            }

            // 1. Esegui un primo controllo al caricamento della pagina
            this.handleResize();

            // 2. Aggiungi un listener per gestire i cambiamenti (es. ridimensionamento finestra)
            // Usiamo il bind(this) per assicurarci che 'this' si riferisca alla nostra classe
            this.desktopMediaQuery.addEventListener('change', this.handleResize.bind(this));
        });
    }

    /**
     * Gestisce l'attivazione o disattivazione della logica 
     * in base alla dimensione dello schermo.
     */
    handleResize() {
        if (this.desktopMediaQuery.matches) {
            // Se siamo su desktop e l'observer non è già attivo, lo creiamo
            if (!this.observer) {
                this.setupObserver();
            }
        } else {
            // Se siamo su mobile, distruggiamo l'observer se esiste
            this.destroyObserver();
        }
    }

    /**
     * Inizializza e configura l'IntersectionObserver.
     */
    setupObserver() {
        const observerOptions = {
            root: null,
            threshold: 0.5,
        };

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const imageId = $(entry.target).data('swap');
                    this.images.removeClass('is-active');
                    const imageToActivate = this.$element.find(`.locker__image[data-image="${imageId}"]`);
                    if (imageToActivate.length) {
                        imageToActivate.addClass('is-active');
                    }
                }
            });
        }, observerOptions);

        this.textSections.each((index, section) => {
            this.observer.observe(section);
        });
    }

    /**
     * Disconnette l'observer e pulisce lo stato.
     */
    destroyObserver() {
        if (this.observer) {
            // Smette di osservare tutti gli elementi
            this.observer.disconnect();
            // Rilascia le risorse impostando l'observer a null
            this.observer = null;
            // Opzionale: resetta lo stato visuale rimuovendo la classe attiva da tutte le immagini
            this.images.removeClass('is-active');
        }
    }
}